module.exports = __webpack_public_path__ + "static/media/link-vefsjonvarp.12c10588.jpg";